import * as React from 'react';
import  '../App.scss';
import { useNavigate } from 'react-router';
import { FontIcon} from '@fluentui/react';
import { useAppContext } from './AppContext';
//import ScannerCircle from './ScannerCircle';

export default function Header() {

    const navigate = useNavigate();
    const signedIn = localStorage.getItem('signed_in') === 'true';
    const userEmail = localStorage.getItem('signed_in_email') || '';
    const userId = localStorage.getItem('signed_in_id') || '';     
    const {appData, setAppData} = useAppContext(); // <-- get context method 
    
    return ( 
        <div className="App-header">
            <FontIcon aria-label="Shop" iconName="Shop" className="FontIcon" style={{float: 'left', paddingLeft: '10px'}} onClick={() => navigate("/")}/>
            <FontIcon onClick={() => navigate("/Menu")} aria-label="CollapseMenu" iconName="CollapseMenu" className="FontIcon" style={{float: 'right', marginRight: '10px'}} />
            <FontIcon onClick={() => navigate("/Login")} aria-label="UserRemove" iconName={signedIn ? "UserFollowed" : "UserRemove"} className="FontIcon" style={{float: 'right', marginRight: '20px'}} />
                
            {signedIn &&
                <>
                    {/* <FontIcon onClick={() => navigate("/Heathmap")} aria-label="Map" iconName={"globe"} className="FontIcon" style={{float: 'right', marginRight: '20px'}} /> */}
                    <FontIcon onClick={() => { setAppData({ ...appData, newReport: false }); navigate("/Reports"); }} aria-label="Items" iconName={"AnalyticsReport"} className="FontIcon" style={{float: 'right', marginRight: '20px'/* , animation: appData.newReport ? 'blink 1s infinite' : 'inherit' */}} />
                    {appData.newMessages > 0 ? (
                        <div
                            key={appData.newMessages}
                            className="chat-circle"
                            onClick={() => { setAppData({ ...appData, newMessages: 0 }); navigate("/Chat"); }}
                        >
                            <FontIcon iconName="Chat" className="chat-icon" />
                            <p className="chat-count">{appData.newMessages}</p>
                        </div>
                    ) : (
                        <FontIcon
                            onClick={() => navigate("/Chat")}
                            aria-label="Chat"
                            iconName="OfficeChat"
                            className="FontIcon"
                            style={{float: 'right', marginRight: '20px'}}
                        />
                    )}
        
                    <FontIcon onClick={() => navigate("/Camera?p=Camera")} aria-label="Camera" iconName={"Camera"} className="FontIcon" style={{float: 'right', marginRight: '20px'}} />
                    <FontIcon onClick={() => navigate("/Search")} aria-label="Search" iconName={"Search"} className="FontIcon" style={{float: 'right', marginRight: '20px'}} />
                    {
                        /* appData.scanning.length > 0 && (
                            <ScannerCircle count={appData.scanning.length}/>
                        ) */
                    }
                </>
            }
        </div>
    )
}